module.exports = __webpack_public_path__ + "static/media/95.b14d00d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/95.svg
// module id = 176
// module chunks = 0